import { RSAA } from "../middlewares/redux-api-middleware";
import { normalize } from "normalizr";

import { API, BANNERS_PER_PAGE } from "../config";
import { BANNER_PREVIEWS } from "../constants/bannerConstants";
import { bannerPreviewSchema } from "../schemas";
import { DEFAULT_COLLECTION } from "../selectors/bannerPreviews";
import { FUNC_REPLACE } from "../reducers/entities/collectionsReducer";


export function fetchItems(page = 1, perPage = BANNERS_PER_PAGE, fetchOptions = {}) {
  const meta = {
    collection: fetchOptions.collection || DEFAULT_COLLECTION,
    func: FUNC_REPLACE,
  };

  return function fetchItemsThunk(dispatch) {
    return dispatch({
      [RSAA]: {
        endpoint: `${API}/banners?page=${page}&per_page=${perPage}`,
        types: BANNER_PREVIEWS.types({
          all: { meta },
          success: {
            payload: parseResponse,
          },
          failed: {
            payload: errorHandler
          }
        }),
      }
    });

    async function errorHandler(action, state, res) {
      return {};
    }

    async function parseResponse(action, state, res) {
      const { banners, meta } = await res.json();

      return {
        ...normalize(banners, [bannerPreviewSchema]),
        pagination: meta,
      };
    }
  };
}